import * as React from 'react';
import './index.scss';
import NewTitle from './NewTitleRun';
interface Props {
  notA?: boolean;
  children?: any;
}
const StaticHead: React.FC<Props> = (props) => {
  return (
    <div className={`static-head ${props.notA ? 'notA' : ''}`}>
      <NewTitle />
      {props.children}
    </div>
  );
};
export default StaticHead;
